import { action ,makeObservable} from 'mobx';
import { AppStore } from './store';

class AppAction extends AppStore {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    // 可以添加一些特定的业务 action
    @action
    async initApp() {
        this.setLoading(true);
        try {
            // 应用初始化逻辑
            this.detectPlatform();
            // 其他初始化操作...
        } finally {
            this.setLoading(false);
        }
    }

    @action
    updateRouteInfo(route) {
        this.setCurrentRoute(route);
        // 路由变化时的其他逻辑
    }
}

export default AppAction;